import { useState } from "react";
import { Header, HeaderWrapper } from "./Components";


export default function TableHeaderCol({children}){
    return (
        <Header>
            <HeaderWrapper>
                {children}
            </HeaderWrapper>
        </Header>
        
    )
}